<template>
  <v-container id="tickets" tag="section">
    <base-v-component heading="Tickets del Negocio " />
    <base-material-card
      color="indigo"
      icon="mdi-laptop"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click.stop="showDialog()">{{
          formTitle
        }}</v-btn>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" max-width="700px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row wrap>
                  <v-col xs12 sm6>
                    <v-text-field
                      v-model="nombre"
                      label="Nombre"
                      :error-messages="nombreErrors"
                      messages="Sin relevancia"
                    ></v-text-field>
                  </v-col>
                  <v-col xs12 sm6>
                    <v-select
                      :items="tiposTickets"
                      v-model="tipo"
                      label="Tipo"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <template v-if="!imagenSrc">
                    <v-col cols="12" sm="6">
                      <v-file-input
                        accept="image/*"
                        label="Imagen Logo"
                        v-model="imagen"
                      ></v-file-input>
                    </v-col>
                  </template>
                  <template v-else>
                    <v-col cols="12" sm="4">
                      <v-img :src="imagenSrc"></v-img>
                    </v-col>
                    <v-col cols="12" sm="2">
                      <v-btn text @click="imagenSrc = null">Cambiar</v-btn>
                    </v-col>
                  </template>
                </v-row>
                <v-row v-if="esCaja">
                  <v-col cols="12" md="6">
                    <v-select
                      :items="$store.state.tickets.cabeceraTicketsItems"
                      v-model="cabeceraTicket"
                      label="Tipo cabecera ticket"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="esCocina">
                  <v-col cols="12"> <h3 class="text-center">Cocinas</h3></v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="categorias"
                      v-model="categoriasSelects"
                      label="Categorías a filtrar"
                      multiple
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="$store.state.tickets.sizeItems"
                      v-model="sizeCocina"
                      label="Tamaño texto cocina"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      :items="productosNoEnCategorias"
                      v-model="productosSelectsSi"
                      label="Productos que SÍ imprimirá"
                      multiple
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      :items="productosSiEnCategorias"
                      v-model="productosSelectsNo"
                      label="Productos que NO imprimirá"
                      multiple
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="reglasEscritura"
                      label="Texto a cambiar"
                      auto-grow
                      filled
                      outlined
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      v-if="negocio.mapeoNeo"
                      color="secondary"
                      @click="traerReglasEscrituraMapeo"
                      :loading="loadingReglas"
                      >Copiar reglas de escritura desde Mapeo</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
                :loading="loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="tickets"
        :loading="loading"
        :search="search"
      >
        <template v-slot:item.acciones="{ item }">
          <v-row class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-btn
              class="px-2 ml-1"
              color="success"
              min-width="0"
              small
              @click="editItemDialog(item)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              class="px-2 ml-1"
              color="red"
              min-width="0"
              small
              @click="deleteItem(item)"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>


<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  validations: {
    nombre: { required, minLength: minLength(4) },
  },
  data() {
    return {
      loading: false,
      loadingReglas: false,
      loadingForm: false,
      dialog: false,
      search: "",
      id: null,
      nombre: "",
      tipo: null,
      cabeceraTicket: null,
      categoriasSelects: [],
      productosSelectsSi: [],
      productosSelectsNo: [],
      sizeCocina: null,
      reglasEscritura: "",
      imagen: null,
      imagenSrc: null,
      headers: [
        {
          sortable: false,
          text: "Nombre",
          value: "nombre",
        },
        {
          sortable: false,
          text: "Tipo",
          value: "tipo",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    esCocina() {
      return this.tipo === "cocina1" || this.tipo === "cocina2";
    },
    esCaja() {
      return this.tipo === "caja1" || this.tipo === "caja2";
    },
    formTitle() {
      return this.isEdit ? "Editar Ticket" : "Nuevo Ticket";
    },
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      tickets: (state) => state.tickets.ticketsArray,
      tiposTickets: (state) => state.tickets.tiposTickets,
    }),
    productosSiEnCategorias() {
      return this.productosListado
        .filter((p) => !this.categoriasSelects.includes(p.categoria))
        .map((p) => {
          return {
            text: p.nombreMostrar,
            value: p.id,
          };
        });
    },
    productosNoEnCategorias() {
      return this.productosListado
        .filter((p) => this.categoriasSelects.includes(p.categoria))
        .map((p) => {
          return {
            text: p.nombreMostrar,
            value: p.id,
          };
        });
    },
    ...mapGetters({
      negocio: "app/negocioGestObj",
      restaurantes: "restaurantes/getRestaurantesListado",
      restaurantesSelect: "restaurantes/getRestaurantesSelect",
      categorias: "categorias/getCategoriasSelect",
      productos: "productos/getProductosSelect",
      productosListado: "productos/getProductosListado",
    }),
    subtitle() {
      return "Listado de tickets de " + this.negocio.nombre;
    },
    accion() {
      return this.id ? "edit" : "add";
    },
    isAdd() {
      return this.accion == "add";
    },
    isEdit() {
      return this.accion == "edit";
    },
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push("Nombre es obligatorio");
      return errors;
    },
    reglasEscrituraArray: {
      get() {
        var res = [];
        this.reglasEscritura.split("\n").forEach((linea) => {
          let array = linea.split(":");
          res.push({
            antes: array[0] ? array[0] : "",
            despues: array[1] ? array[1] : "",
          });
        });
        return res;
      },
      set(v) {
        if (v) {
          this.reglasEscritura = v
            .map((l) => {
              if (l.antes.length > 0) return l.antes + ":" + l.despues;
            })
            .filter((l) => l && l.length > 0)
            .join("\n");
        }
      },
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.$v.$reset();
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    reiniciarDatos() {
      this.nombre = "";
      this.tipo = null;
      this.id = null;
      this.categoriasSelects = [];
      this.productosSelectsSi = [];
      this.productosSelectsNo = [];
      this.reglasEscritura = "";
    },
    reload() {
      this.getTickets();
    },
    editItemDialog(item) {
      this.nombre = item.nombre;
      this.tipo = item.tipo;
      this.id = item.id;
      this.categoriasSelects = item.categoriasSelects
        ? item.categoriasSelects
        : [];
      this.productosSelectsSi = item.productosSelectsSi
        ? item.productosSelectsSi
        : [];
      this.productosSelectsNo = item.productosSelectsNo
        ? item.productosSelectsNo
        : [];
      this.imagenSrc = item.logo;
      this.dialog = true;
      this.sizeCocina = item.sizeCocina;
      this.cabeceraTicket = item.cabeceraTicket;
      this.reglasEscrituraArray = item.reglasEscritura;
    },
    addTicket() {
      let t = {
        nombre: this.nombre,
        id: this.id,
        tipo: this.tipo,
        sizeCocina: this.sizeCocina ? this.sizeCocina : null,
        cabeceraTicket: this.cabeceraTicket ? this.cabeceraTicket : null,
        categoriasSelects: this.categoriasSelects,
        productosSelectsSi: this.productosSelectsSi,
        productosSelectsNo: this.productosSelectsNo,
        reglasEscritura: this.reglasEscrituraArray
          ? this.reglasEscrituraArray
          : [],
      };
      if (this.imagen) {
        t.imagen = this.imagen;
      }
      return this.$store.dispatch("tickets/addTicket", t);
    },
    save() {
      let _vm = this;
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.loadingForm = true;
        if (this.isAdd || this.isEdit) {
          this.addTicket()
            .then((res) => {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Ticket grabado con éxito",
              });
              _vm.getTickets();
              _vm.dialog = false;
            })
            .catch((error) => {
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al guardar el ticket: " + error,
              });
            })
            .finally(() => {
              _vm.loadingForm = false;
            });
        }
      }
    },
    getTickets() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("tickets/getTickets").finally(() => {
        _vm.loading = false;
      });
    },
    deleteItem(item) {
      let r = confirm("¿Quieres eliminar el ticket? (no se puede deshacer)");
      if (r) {
        this.loading = true;
        let _vm = this;
        this.$store
          .dispatch("tickets/deleteTicket", item)
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Ticket eliminado",
            });
            _vm.getTickets();
          })
          .catch((error) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al eliminar: " + error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    showDialog() {
      this.dialog = true;
      //this.$nextTick(this.$refs.nombreReferencia.focus())
    },
    traerReglasEscrituraMapeo() {
      let _vm = this;
      this.loadingReglas = true;
      this.$store
        .dispatch("tickets/traerReglasEscrituraMapeo")
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Reglas añadidas con exito",
          });
          this.reglasEscrituraArray = [...this.reglasEscrituraArray, ...res];
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al generar las reglas: " + error,
          });
        })
        .finally(() => {
          this.loadingReglas = false;
        });
    },
  },
  mounted() {
    let _vm = this;
  },
};
</script>

<style>
</style>